<template>
    <div></div>
</template>
<script>
export default {
  props: {
    sampleId: {
      type: String,
      default: ''
    },
    currentSampleId: {
      type: String,
      default: ''
    },
    labOrderId: {
      type: String,
      default: ''
    },
    isAgentOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAdult () {
      return this.$route.name === 'adult-sell-order-detail' || this.$route.name === 'adult-sell-order-handle' || this.$route.query.isAdult
    }
  },
  created () {
    // 实验室订单的重采订单
    if (this.isAgentOrder) {
      this.$router.push(`/${this.isAdult ? 'sell-order-form' : 'lab-order-form'}/true/${this.labOrderId}?recollect=true`)
    } else {
      // 商城订单的重采订单'
      let isAdult = this.$route.name === 'adult-sell-order-handle' || this.$route.params.isAdult || this.$route.name === 'adult-sell-order-detail'
      let sampleType = isAdult ? 'ADULT_STORAGE' : 'GENE_DETECTION'
      this.$router.push(`/waiting-for-sample-recollect/sample-recollect-detail/${this.currentSampleId}/${sampleType}`)
    }
  }
}
</script>
